import { BEEntity } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEEntity';
import { EnumBEType } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumBEType';

export class BEEntityExtend {
  public static Init(dto: BEEntity) {
    dto.bEType = EnumBEType.BEEntity;
  }
}
